import authenticationCreator from './creator';

export default authenticationCreator;
